import {Button, CardMedia, FormControlLabel, Switch, TextField} from "@mui/material"
import React from "react"
import {PersonaType} from "../../models";

export type ContentItem = {
    id: number; order: number; locked: boolean; name: string; src: string; contentUrl: string; hide?:boolean;
}

type EditType = | "content" | "stim" | "story" | "watch" | "watchStim" | "reel" | "reelStim" | "video" | "videoStim" | "music" | "musicStim" | "gmail" | "yt" | "ytStim";

const editTypeByPersonaAndPage: Partial<
  Record<PersonaType, Partial<Record<string, EditType>>>
> = {
  default: {
    content: "content",
    stims: "stim",
    stories: "story",
    watch: "watch",
    watchStims: "watchStim",
    reel: "reel",
    reelStims: "reelStim",
  },
  reel: {
    content: "reel",
    stims: "reelStim",
  },
  streamer: {
    content: "video",
    stims: "videoStim",
  },
  video: {
    video: "yt",
    videoStims: "ytStim",
  },
  music: {
    content: "music",
    stims: "musicStim",
  },
  gmail: {
    content: "gmail",
    // if gmail should apply regardless of page, you can handle that below instead
  },
};

const getEditType = (personaType: PersonaType, page: string): EditType => {
  if (personaType === "gmail") return "gmail";

  console.log(personaType, page);
  const mapped = editTypeByPersonaAndPage[personaType]?.[page];
  return mapped ?? "content";
};

interface PersonaContentCardProps<T extends ContentItem> {
    item: T;
    onLinkageChange: (id: number, linkage: { order: number, locked: boolean }) => void;
    onItemEdit: (id: number, type: EditType) => void;
    onItemUnlink: (item: T) => void;
    personaType: PersonaType;
    page: string;
    disabled?: boolean;
}

export const PersonaContentCard = <T extends ContentItem, >({
                                                                item,
                                                                onLinkageChange,
                                                                onItemEdit,
                                                                onItemUnlink,
                                                                personaType,
                                                                page,
                                                                disabled = false,
                                                            }: PersonaContentCardProps<T>) => {
    function handleOrderChange(order: number) {
        onLinkageChange(item.id, {order, locked: item.locked,});
    }

    function handleLockedChange(locked: boolean) {
        onLinkageChange(item.id, {order: item.order, locked,});
    }

    return (<div style={{display: "flex", justifyContent: "space-between"}} className="edit-container drag-container"
                 key={item.id}>
        {item.hide && (
            <>Testing Hide</>
        )}
            <div className="drag-panel">
                <div style={{width: "72px", minWidth: "72px", padding: "5px", backgroundColor: "#00b9db"}}
                     className="drag-order">
                    <TextField
                        inputProps={{min: 0, type: "number"}}
                        className="spacer"
                        style={{color: "white"}}
                        variant="outlined"
                        label="Order"
                        name="order"
                        value={item.order}
                        onChange={(e) => handleOrderChange(parseInt(e.target.value))}
                    />
                </div>
                <div className="square" style={{ width: "72px", minWidth: "72px" }}>
                    {(() => {
                        const src = personaType === "video" ? item.contentUrl : item.src;

                        if (src) {
                            return (
                                <CardMedia
                                    component={src.split(".").pop() === "mp4" ? "video" : "img"}
                                    image={src}
                                    title={item.name}
                                />
                            )
                        } else {
                            return (
                                <div className="noSrc">
                                    No Src
                                </div>
                            )
                        }
                    })()}
                </div>

                <div>
                    <h1 style={{
                        width: "360px",
                        maxWidth: "360px",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        lineClamp: 1,
                        maxLines: 1
                    }}>{item.name}</h1>
                </div>
            </div>
            <div className="unlink" style={{paddingRight: "16px"}}>
                <FormControlLabel className="spacer"
                                  control={<Switch
                                      checked={item.locked}
                                      onChange={(_, checked) => handleLockedChange(checked)}
                                      name="locked"
                                      color="primary"
                                  />}
                                  label="Locked"
                />
                <Button
                    variant="contained"
                    color="primary"
                    disabled={disabled}
                    onClick={() => onItemUnlink(item)}
                >
                    Unlink
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    style={{marginLeft: "10px"}}
                    onClick={() => onItemEdit(item.id, getEditType(personaType, page))}>
                    Edit
                </Button>
            </div>
        </div>)
}
